import React from "react"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { ColorName } from "@tenforce/toolbox-default-style"

import { useAppSelector } from "../../../hooks"

import ActionHandlerRegistry from "../utils/ActionHandlerRegistry"
import { selectAIModalById } from "../selectors"
import { IId } from ".."

export type Props = IId

export default function Inputs({ id }: Props): JSX.Element {
    const AIModalData = useAppSelector((state) => selectAIModalById(state, id))

    if (!AIModalData) {
        return <></>
    }

    const { inputButtons, isLoading } = AIModalData

    if (inputButtons.length === 0) {
        return <></>
    }

    return (
        <footer
            className="tw-px-2 tw-py-1 bg-white tw-rounded-b-lg"
            data-ft-component="inputs"
        >
            {inputButtons.map((button) => {
                const onClickAction = ActionHandlerRegistry.get(button.id)

                if (!onClickAction) {
                    return <React.Fragment key={button.id} />
                }

                return (
                    <Action
                        key={button.id}
                        data-ft-component="inputButton"
                        data-ft-id={button.id}
                        actionType={ActionType.button}
                        isTransparent={true}
                        textColor={ColorName.Goldenrod}
                        onClick={onClickAction}
                        isLoading={isLoading}
                        extraClasses="animate-ai-border"
                    >
                        {button.label}
                    </Action>
                )
            })}
        </footer>
    )
}
